import Url from './urlConf.js';
import request from '../../utils/request.js';
import COVERAPP from './COVERAPP.js';
function getAppVersion(){
  return new Promise(function(resolve, reject){
    let result = COVERAPP.Attribute.isApp() ? COVERAPP.Attribute.appVersion() :  COVERAPP.Attribute.isWeixin() ? 'weixin' : 'others';
    resolve(result);
  });
}
function isAppOrWeixin(){
  return new Promise(function(resolve, reject){
    let result = COVERAPP.Attribute.isApp() || COVERAPP.Attribute.isWeixin();
    resolve(result);
  });
}
function getCustomSetting(id){
  let url = Url.setting(id || '99');
  return request({
    url
  }).then(res=>res.data)
}

function handleData(res){
  let temp = res;
  let mediaType = true;
  Array.isArray(temp.data) || (temp.data = [temp.data]);
  temp.data.map(item=>{
    if(item.album && item.album.length){
      mediaType = /\.(jpg|jpeg|png|bmp)$/.test(item.album[0]);
      item.mediaType = mediaType ? 'image' : 'video';
    }
  });
  return temp;
}
function getData(url, token, preProcess){
  let tempConfig = { url: url };
  preProcess && (tempConfig.handleData = typeof preProcess == 'number' ? handleData : preProcess);
  token && (tempConfig.token = typeof token == 'string'? token : token.access_token);
  return request(tempConfig).then(res => res);
}
function getList(id, tokens, page, include,topic){
  return getData(Url.list(id, page, include,topic), tokens, 1);
}

function getDetail(id, tokens){
  return getData(Url.detail(id), tokens, 1);
}
function getComments(id, tokens){
  return getData(Url.comments(id), tokens);
}
function getProfile(id, tokens){
  return getData(Url.profile(id), tokens, function(res){
    let temp = res;
    let mediaType = true;
    Array.isArray(temp.data.contents) || (temp.data.contents = [temp.data]);
    temp.data.contents.map(item=>{
      if(item.album && item.album.length){
        mediaType = /\.(jpg|jpeg|png|bmp)$/.test(item.album[0]);
        item.mediaType = mediaType ? 'image' : 'video';
      }
    });
    return temp;
  });
}
function postData(params){
  let tempConfig = { 
    url: params.url, 
    method: 'POST',
    token: params.token 
  };
  params.data && (tempConfig.data = params.data);
  params.preProcess && (tempConfig.handleData = handleData);
  return request(tempConfig).then(res => res);
}
function follow(uid, token){
  return postData({
    url: Url.follow(uid),
    token: token
  });
}

function zan(id, token){
  return postData({
    url: Url.zan(id),
    token: token
  });
}
function postComment(params){
  return postData({
    url: Url.comment(params.id),
    data: params.data,
    token: params.token
  });
}
function deleteContent(id, token){
  let tempConfig = { 
    url: Url.deleteContent(id, id), 
    method: 'DELETE',
    token: token 
  };
  return request(tempConfig).then(res => res);
}
function publish(typeid, data, token){
  // https://marketing.chuanbaoguancha.cn/v1/community/content?type_id=99
  return postData({
    url: Url.publish(typeid),
    data: data,
    token: token
  });
}

export {
  isAppOrWeixin,
  getAppVersion,
  getCustomSetting,
  getList,
  follow,
  zan,
  getDetail,
  getComments,
  getProfile,
  postComment,
  deleteContent,

  publish

}